import { FieldViewModel, getDistinctValues, INMaxCropGroup } from "../../../omnia"
import { ICroppingGroupItem, INtrReq, INutritionService, NutrientType } from "../../../types"
import { getNutrientTypes } from "../../../utils"

export class CroppingVm implements ICroppingGroupItem {

    static create(svc: INutritionService, cropping: FieldViewModel[]): CroppingVm[] {

        let reqProvider = svc.getRequirementsProvider();

        let models = cropping.map(c => {

            let req = reqProvider.getCroppingInitialRequirements(c.croppingId);

            if (req) {
                let zones = reqProvider.getInitialRequirements(c.croppingId, true);
                let nmaxGroup = svc.getNMaxCroppingGroup(c.croppingId);
                return new CroppingVm(c, req, zones, nmaxGroup);
            }

        }).filter(r => !!r);

        return models;

    }

    public selected: boolean;
    public excluded: boolean = false;

    public multipleZonesNutrientMask: number;

    constructor(
        public croppingVm: FieldViewModel,
        public req: INtrReq,
        public zones: INtrReq[],
        public nmaxGroup: INMaxCropGroup,
        public readonly authorized = croppingVm.authorized
    ) {

            this.setupNutrients();

    }

    private setupNutrients() {

        let mask = getNutrientTypes().reduce((mask, type) => {

            let key = NutrientType[type];

            let reqs = getDistinctValues(this.zones.map(z => z["Required" + key]).filter(r => !!r), r => r);
            if (reqs.length > 1) {
                mask |= Math.pow(2, type - 1);
            }

            return mask;

        }, 0);

        this.multipleZonesNutrientMask = mask;

    }

    get cropping() {
        return this.croppingVm.cropping
    }

    get field() {
        return this.croppingVm.field
    }

    get croppingId() {
        return this.croppingVm.croppingId;
    }

    get crop() {
        return this.croppingVm.crop;
    }

    get area() {
        return this.croppingVm.area
    }

    get hasRequirements() {
        return true
    }

    get uncropped(): boolean {
        return (!this.crop) || (!this.crop.CropId);
    }

    get cssColor() {
        return this.croppingVm.cssColor
    }

    getDescription(includeCrop: boolean): string {
        return this.croppingVm.getCroppingDescription(true, false, includeCrop);
    }

    get visible(): boolean {
        return this.selected || (!this.excluded);
    }

    getRequirement(nutrientKey: string): number {
        return this.req["Required" + nutrientKey];
    }

}
